import React from 'react'
import glamorous from 'glamorous'
import PropTypes from 'prop-types'
import content from 'pp-react-l10n'
import { Text } from '@paypalcorp/pp-react'
import { smallAndSmaller } from 'lib/styles/media-queries'

const i18n = content('transfer/aucip')

const Container = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  alignItems: 'center',
  margin: '0 5rem',
  [smallAndSmaller]: {
    margin: '0',
  },
  marginTop: '5rem',
})

const Header = glamorous.h1({
  fontSize: '2.2rem',
  marginTop: '1rem',
  lineHeight: '2rem',
  [smallAndSmaller]: {
    fontSize: '1.5rem',
  },
})

const Paragraph = glamorous.div({
  margin: '0.5rem',
})

const Button = glamorous.button('ppvx_btn', {
  marginBottom: '20px',
  padding: '10px 70px',
  marginTop: '5%',
})

const Link = glamorous.a('ppvx_link', {
  cursor: 'pointer',
})

export default function ErrorContent({ onConfirm, onCancel, cdnHostName }) {
  const imgUrl = `${cdnHostName}/digitalassets/c/paypal-ui/illustrations/svg/warning.svg`
  return (
    <Container>
      <img src={imgUrl} style={{ width: '144px' }} alt=""></img>
      <Header>{i18n('body.primary')}</Header>
      <Paragraph>
        <Text size="md">{i18n('body.secondary')}</Text>
      </Paragraph>
      <Button onClick={onConfirm}>{i18n('button.confirm')}</Button>

      {/* eslint-disable-next-line consumerweb/require-pagename */}
      <Link onClick={onCancel}>{i18n('link.cancel')}</Link>
    </Container>
  )
}

ErrorContent.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  cdnHostName: PropTypes.string.isRequired,
}
